<template>
    <span>
        <span v-if="isHearsay">
            <div style="padding-top:2px; margin-bottom:2px">
                <img src="../../assets/images/whitelabels/hearsay/hearsay-content-plus.svg" height="20"/>
            </div>
        </span>
        <span v-else-if="isSeismic" class="d-flex align-items-top">
                <img src="../../assets/images/whitelabels/seismic/PremCont.svg" style="width: 30px; height: 30px; margin-right: 10px; margin-top: 3px;"/>
            <div class="d-inline-block" style="font-size: .9em; line-height: 1.2">
                <div>{{ appByUpcontent }}</div>
                <div class="small" style=" font-size: .6em">by UpContent</div>
            </div>
        </span>
        <span v-else-if="appByUpcontent" class="d-flex align-items-top">
            <upcontent-logo style="top: 3px"/>
            <div class="d-inline-block" style="font-size: .9em; line-height: 1.2">
                <div>{{ appByUpcontent }}</div>
                <div class="small" style=" font-size: .6em">by UpContent</div>
            </div>
        </span>
        <span v-else>
            <img height="38" src="@/assets/images/logo.png" alt="UpContent">
        </span>
    </span>
</template>

<script>
import {mapGetters} from 'vuex';
import UpcontentLogo from '@/components/Navigation/Logo'
import RouteContext from '@/utilities/RouteContext'
export default {
    name: "AppLogo",
    components: {
        UpcontentLogo
    },
    mixins: [RouteContext],
    computed: {
        ...mapGetters({
            isDealerVenom: 'isDealerVenom',
            isHearsay: 'isHearsay',
            isSocialAdvisors: 'isSocialAdvisors',
            vendor: 'vendor',
            subvendor: 'subvendor',
            appByUpcontent: 'appByUpcontent',
            isAmplify: 'isAmplify',
            isEmbed: 'isEmbed',
            appName: 'appName',
        }),
        isSeismic() {
            return this.vendor === 'seismic';
        }
    }
}
</script>

<style scoped>

</style>
